import ButtonFunction from "./shared/ButtonFunction";
import TextInputHorizontalTag from "./shared/TextInputHorizontalTag";
import NavLabel from "./shared/NavLabel";
import GeneralContext from "../context/GeneralContext";
import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";

const fetch = require('../utils/fetch');

function LoginCard({additionalFunction = emptyFunction}) {

  const {
    changeActiveMode,
    changeModalTitle,
    changeModalText,
    changeModalType,
    resizeIndex,
    animationDuration,
    animationDelay
  } = useContext(GeneralContext);

  const [documentId, setDocumentId] = useState("");
  const changeDocumentId = (e) => {
    setDocumentId(e.target.value);
  }

  const [password, setPassword] = useState("");
  const changePassword = (e) => {
    setPassword(e.target.value);
  }

  const passwordMode = () => {
    changeActiveMode('password');
  }
  const navigate = useNavigate();

  const loginFunction = async () => {
    const modal = document.getElementById("myModal");
    if (documentId === '' || password === '') {
      changeModalTitle('Error al ingresar');
      changeModalText('No puede haber ningún campo vacío');
      changeModalType('alert');
      modal.style.display = "block";
    } else {
      const data = {document: documentId, password: password};
      const response = await fetch.fetchBody('', 'POST', data);
      if (response.success) {
        localStorage.setItem('token', response.token);
        const role = JSON.parse(atob(localStorage.getItem('token').split('.')[1])).role;
        additionalFunction();
        animationDuration.current = 1;
        animationDelay.current = 1.5;
        window.removeEventListener("resize", resizeIndex);
        if (role === 'user') {navigate('/normal-user');}
        if (role === 'admin') {navigate('/admin-user');}
        if (role === 'super_admin') {navigate('/super-admin-user');}
      } else {
        changeModalTitle('Error al ingresar');
        changeModalText(response.reason);
        changeModalType('alert');
        modal.style.display = "block";
      }
    }
  }

  return (
    <div id='loginCard'>
      <>
        <TextInputHorizontalTag label='Documento' changeEvent={changeDocumentId} />
        <TextInputHorizontalTag label='Contraseña' type='password' changeEvent={changePassword}/>
        <NavLabel navFunction={passwordMode}>Olvidé mi contraseña</NavLabel>
        <br />
        <br />
        <ButtonFunction buttonClass='loginButton' buttonFunction={loginFunction}>Ingresar</ButtonFunction>
      </>
    </div>
  )
}

const emptyFunction = () => {}

export default LoginCard